import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {PreparationComponent} from './preparation/preparation.component';
import {GameComponent} from './game/game.component';
import {OrderComponent} from './order/order.component';

const routes: Routes = [
  {path: '', component: PreparationComponent},
  {path: 'order', component: OrderComponent},
  {path: ':id', component: GameComponent},
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
